// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"4f9e9189","369":"e514b9e7","848":"9474c0eb","867":"71c79aa7","994":"b7784e2b"}[chunkId] + ".chunk.css";
};